export default __webpack_public_path__ + "static/media/Huawei.4541d956.png";